

import React, { Component } from 'react';
import Section from 'grommet/components/Section';
import Tiles from 'grommet/components/Tiles';
import Tile from 'grommet/components/Tile';
import Box from 'grommet/components/Box';
import Anchor from 'grommet/components/Anchor';
import Layer from 'grommet/components/Layer';
import Button from 'grommet/components/Button';

export default class Home extends Component {
  constructor (props) {
    super(props);
    this.state = {alertNull: false}
    this._onSelectStatisticsDataSource = this._onSelectStatisticsDataSource.bind(this);
    this._onSelectStatisticsExplore = this._onSelectStatisticsExplore.bind(this);
    this._onSelectStatisticsFitModel = this._onSelectStatisticsFitModel.bind(this);
    this._onCloseOptions = this._onCloseOptions.bind(this)
  }
  _onSelectStatisticsExplore(event) {
    if (this.props.dataObjectNull) {
      this.setState({alertNull: true})
    } else {
      this.props.onSelectStatisticsExplore(event);
    }  
  }
  _onSelectStatisticsFitModel(event) {
   /*  if (this.props.dataObjectNull) {
      this.setState({alertNull: true})
    } else { */
    this.props.onSelectStatisticsFitModel(event);
    //}
  }
  _onSelectStatisticsDataSource(event) {
    this.props.onSelectStatisticsDataSource(event);
  }
  _onCloseOptions() {
    this.setState({alertNull: false})
  }
  render() {
    const {alertNull} = this.state;
    let alert;
    if (alertNull) {
      alert = <Layer onClose={this._onCloseOptions} closer={true} align="center" >
      <Box pad={{vertical: 'large'}} style={{width: "100%", height: "100%"}}>
        <p>We need some data before doing anything. Click on Data Source.</p>
        <br/>
        <Button label='Ok'
                        type='submit'
                        primary={true}
                        onClick={this._onCloseOptions} />  
      </Box>
      
    </Layer>
    } else {
      alert = <div></div>
    }
    let dataSourceElement, title;
    //<h3 style={{paddingTop: "20px"}}>1. Data Source</h3>
    if (this.props.statisticsDataSource) {
      dataSourceElement = (
                  <Tiles fill={true} flush={true} justify="center" responsive={true} selectable={true} size={"small"} onSelect={this._onSelectStatisticsDataSource}>
                  {this.props.statisticsDataSource.map((input, key)=>{
                    const Icon = input.icon
                    return (
                      <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={key} style={{maxWidth: "200px"}}>
                      <Box pad="small" colorIndex="light">
                        <h4>{input.name}</h4>
                        <Box align="center">
                          <Anchor>
                            <Icon size="large" colorIndex="grey-1"/>
                          </Anchor>
                        </Box>
                      </Box>	
                    </Tile> 
                    )
                  })}
                  </Tiles>)
        title = "1. Data Source"
    } else {
      dataSourceElement = <div></div>
      title = ""
    }
    return (
        <div>
          <Button label="Get Started" onClick={this._onSelectStatisticsFitModel.bind(this, 0)}/>
          {alert}
          {/* <Box>
            <Section style={{height: "60vh", justifyContent: "center"}}  align="center" pad={{"horizontal": "medium", "vertical": "medium", "between": "small"}} >	  
              <div>
              <Tiles> */}
              {/* <h3 style={{paddingTop: "20px"}}>{title}</h3>
              {dataSourceElement}
                <h3 style={{paddingTop: "20px"}}>2. Explore Data</h3>
                <Tiles fill={true} flush={true} justify="center" responsive={true} selectable={true} size={"small"} onSelect={this._onSelectStatisticsExplore}>
                {this.props.statisticsExplore.map((input, key)=>{
                  const Icon = input.icon
                  return (
                    <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={key} style={{maxWidth: "200px"}}>
                    <Box pad="small" colorIndex="light">
                      <h4>{input.name}</h4>
                      <Box align="center">
                        <Anchor>
                          <Icon size="large" colorIndex="grey-1"/>
                        </Anchor>
                      </Box>
                    </Box>	
                  </Tile> 
                  )
                })}
                </Tiles> 
                <h3 style={{paddingTop: "80px"}}>3. Fit a Model and Predict</h3> */}
                {/* <Tiles fill={true} flush={true} justify="center" responsive={true} selectable={true} size={"small"} onSelect={this._onSelectStatisticsFitModel}>
                {this.props.statisticsFitModel.map((input, key)=>{
                  const Icon = input.icon
                  return (
                    <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={key} style={{maxWidth: "300px"}}>
                    <Box pad="small" colorIndex="light">
                      <h4>{input.name}</h4>
                      <Box align="center">
                        <Anchor>
                          <Icon size="large" colorIndex="grey-1"/>
                        </Anchor>
                      </Box>
                    </Box>	
                  </Tile> 
                  )
                })}
                </Tiles> */}
                {/* <h3 style={{paddingTop: "30px"}}>Chart Library</h3>
                <Tiles fill={true} flush={true} justify="center" responsive={true} selectable={true} size={"small"} onSelect={this._onSelectCharts}>
                {charts.map((input, key)=>{
                  const Icon = input.icon
                  return (
                    <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={key} style={{maxWidth: "300px"}}>
                    <Box pad="small" colorIndex="light">
                      <h4>{input.name}</h4>
                      <Box align="center">
                        <Anchor>
                          <Icon size="large" colorIndex="grey-1"/>
                        </Anchor>
                      </Box>
                    </Box>	
                  </Tile> 
                  )
                })}
                </Tiles> */}
{/*               </Tiles>

              </div>
              
            </Section>
          </Box> */}
        </div>);
    }
};



// WEBPACK FOOTER //
// ./src/components/Elements.js